import React, { useState, useEffect } from 'react';
import "./services.css";
import pcms from "../../assets/pcms.png";
import deepracer from "../../assets/deepracer.png";
import microsoft from "../../assets/microsoft.png";
import helsinki from "../../assets/helsinki.jpg";
import cgpa from "../../assets/apuy2.png"
import vclist2022 from "../../assets/vclist2022.png"
import vclist2023 from "../../assets/vclist2023.png"
import ieee from "../../assets/ieee.png"
import branlitwin from "../../assets/branlit_winner.png"
import safetytech from "../../assets/safetytech.jpg"
import { TbCloudComputing } from "react-icons/tb";
import { FaGoogle, FaAws, FaHeartbeat } from "react-icons/fa";
import { SiMicrosoftazure } from "react-icons/si";


const Services = () => {
    const [toggleState, setToggleState] = useState(0);

    const toggleTab = (index) => {
        setToggleState(index);
        if (index === 1 || index === 2  || index === 3) {
            // Disable scrolling when the modal opens
            document.body.classList.add('no-scroll');
        } else {
            // Enable scrolling when the modal closes
            document.body.classList.remove('no-scroll');
        }
    };

    useEffect(() => {
        function handleKeyPress(event) {
            if (event.key === 'Escape') {
                // Execute toggleTab(0) when the Escape key is pressed
                document.body.classList.remove('no-scroll');
                toggleTab(0);
            }
        }

        // Add the event listener when the component mounts
        window.addEventListener('keydown', handleKeyPress);

        // Remove the event listener when the component unmounts
        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, [toggleState]);
    
    const variants = {
        open: {
          scale: 1,
          transition: {
            duration: 2,
          },
        },
        closed: {
          scale: 0,
          transition: {
            duration: 2,
          },
        },
      };
      
  return (
    <section className="services section" id="milestones">
        <h2 className="section__title bouncing-text" /**/>
        <div className="A">M</div>
            <div className="c">i</div>
            <div className="h">l</div>
            <div className="i">e</div>
            <div className="e1">s</div>
            <div className="v">t</div>
            <div className="e2">o</div>
            <div className="m">n</div>
            <div className="e3">e</div>
            <div className="n">s</div>
            {/* Milestones */}
        </h2>
        <span className="section__subtitle">- My role in daily life -</span>

        <div className="services__container container grid">
            <div className="services__content">
                <div>
                    <i className="uil uil-award services__icon"></i>
                    <h3 className="services__title">Active <br /> Competitor</h3>
                </div>

                <span className="services__button" onClick={() => toggleTab(1)}>
                    View More<i className="uil uil-arrow-right services__button-icon"></i>
                </span>

                <div className={toggleState === 1 ? "services__modal active-modal" : "services__modal"}>
                    <div className="services__modal-content">
                        <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>
                    
                        <h3 className="services__modal-title">
                            Active Competitor
                        </h3>
                        <p className="services__modal-description achievement__justify">
                        From freshie blur blur to competition kaki, I just embrace every challenge that come my way. Work until pengsan, but the wins? The awards, the recognition, those are just bonus for the thrill of competing. Basically, I thrive under pressure and love the feeling of pushing my limits.
                        </p>

                        <div className="scrollable-element">

                            <ul className="services__modal-services grid">
                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle services__modal-icon"></i>
                                    <p className="services__modal-info achievement__justify">
                                    Got
                                        {' '}<b className="hover-text">Outstanding Contribution Award (1st place in two categories)</b>{' '}
                                        in the <b>Open-Source Bootcamp 2025 - Ant International</b>.
                                    </p>
                                </li>
                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle services__modal-icon"></i>
                                    <p className="services__modal-info achievement__justify">
                                    Achieved a 
                                        {' '}<b className="hover-text">Top 6 position out of 107 teams and over 300 participants</b>{' '}
                                        in the <b>EY Young Technology Professional Challenge 2024</b> with an innovative food waste management solution utilizing AI, IoT, and black soldier fly larvae composting technology.
                                    </p>
                                </li>
                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle services__modal-icon"></i>
                                    <p className="services__modal-info achievement__justify">
                                    Advanced to the 
                                        {' '}<b className="hover-text">semi-finals from over thirty teams</b>{' '}
                                        in the <b>Shell Varsity Challenge 2024</b> with a solution incorporating a bidirectional blind spot detection system.
                                    </p>
                                </li>                             
                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle services__modal-icon"></i>
                                    <p className="services__modal-info achievement__justify">
                                    Awarded  
                                        {' '}<b className="hover-text" style={{textDecoration: "underline"}}>1st Runner-Up among 26 teams</b>{' '}
                                        <img
                                            src={safetytech}
                                            alt="Image"
                                            className="popUpImg-left"
                                            style={{top: "5%"}}
                                        />
                                        for developing a 3D gaming website with mini games to enhance PPE training using Azure Services in the<b> Safety Tech Hackathon 2024</b>.
                                    </p>
                                </li>

                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle services__modal-icon"></i>
                                    <p className="services__modal-info achievement__justify">
                                        Got  
                                        {' '}<b className="hover-text" style={{textDecoration: "underline"}}>top 5</b>{' '}
                                        <img
                                            src={branlitwin}
                                            alt="Image"
                                            className="popUpImg-left"
                                            style={{top: "5%"}}
                                        />
                                        out of 95 people by building a Python website in<b> MY Streamlit Hack</b>.
                                    </p>
                                </li>

                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle services__modal-icon"></i>
                                    <p className="services__modal-info achievement__justify">
                                        Achieved 
                                        {' '}<b className="hover-text" style={{textDecoration: "underline"}}>1st place</b>{' '}
                                        <img
                                            src={pcms}
                                            alt="Image"
                                            className="popUpImg-right"
                                            style={{top: "35%"}}
                                        />
                                        in the preliminary rounds of the <b>Innopolis' informatics competition</b>.
                                    </p>
                                </li>

                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle services__modal-icon"></i>
                                    <p className="services__modal-info achievement__justify">
                                        Got 
                                        {' '}<b className="hover-text" style={{textDecoration: "underline"}}>12th position</b>{' '}
                                        <img
                                            src={deepracer}
                                            alt="Image"
                                            className="popUpImg-left"
                                            style={{top: "47%"}}
                                        />
                                        out of 370 teams in <b>APU AWS DeepRacer Competition 2023</b>.
                                    </p>
                                </li>

                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle services__modal-icon"></i>
                                    <p className="services__modal-info achievement__justify">
                                        Took home
                                        {' '}<b className="hover-text">Consolation Prize</b>{' '}
                                        in <b>BAT x APU Ideathon Competition 2023</b>.
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="services__content">
                <div>
                    <i className="services__icon">
                        <FaHeartbeat />
                    </i>
                    <h3 className="services__title">
                        Hobbies & <br /> Lifestyle
                    </h3>
                </div>

                <span className="services__button" onClick={() => toggleTab(2)}>
                    View More <i className="uil uil-arrow-right services__button-icon"></i>
                </span>

                <div className={toggleState === 2 ? "services__modal active-modal" : "services__modal"}>
                    <div className="services__modal-content">
                        <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>
                    
                        <h3 className="services__modal-title">
                            Hobbies & Lifestyle
                        </h3>
                        <p className="services__modal-description achievement__justify">
                        I know I mentioned this earlier, but it's worth saying again - life isn't just about coding! When I'm not behind a screen, you'll find me <b>hitting the gym</b> for gains, smashing shuttlecocks on the <b>badminton</b> court, conquering trails on <b>hiking</b> adventures, or chasing golden hours with my camera for <b>photography</b>. Every frame tells a story. Balance is key, and these activities keep me sane and energized!
                        </p>
                        <div className="scrollable-element">
                            <ul className="services__modal-services grid">
                                {/* Add your hobby content here if needed */}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="services__content">
                <div>
                    <i className="uil uil-book-open services__icon"></i>
                    <h3 className="services__title">
                        Learning & <br/> Growth
                    </h3>
                </div>
                
                <span className="services__button" onClick={() => toggleTab(3)}>View More <i className="uil uil-arrow-right services__button-icon"></i>
                </span>

                <div className={toggleState === 3 ? "services__modal active-modal" : "services__modal"}>
                    <div className="services__modal-content">
                        <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>
                    
                        <h3 className="services__modal-title">
                            Learning & Growth
                        </h3>
                        <p className="services__modal-description achievement__justify">
                        From uni life to cloud certifications and open source contributions, I'm always hungry to learn new things. Whether it's acing exams, contributing to global projects, or collecting certs - the grind never stops!
                        </p>
                    
                        <div className="scrollable-element">
                            <ul className="services__modal-services grid">
                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle services__modal-icon"></i>
                                    <p className="services__modal-info achievement__justify">
                                        Graduated with <b>First Class Honours</b> and <b>CGPA of 3.89 out of 4.0</b> from APU.
                                    </p>
                                </li>

                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle services__modal-icon"></i>
                                    <p className="services__modal-info achievement__justify">
                                        Named to the <b>Vice Chancellor's List</b> from <b>2022 to 2025</b>.
                                    </p>
                                </li>

                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle services__modal-icon"></i>
                                    <p className="services__modal-info achievement__justify">
                                        Awarded <b>Best Student Award</b> for outstanding academic performance and contributions.
                                    </p>
                                </li>

                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle services__modal-icon"></i>
                                    <p className="services__modal-info achievement__justify">
                                        Open source contributor to <b>Ant Group's CodeFuse</b> projects - contributed to {' '}<a href="https://github.com/codefuse-ai/CodeFuse-Embeddings" target="_blank" rel="noreferrer"><b style={{ color: "#333333", textDecoration: "underline" }}>CodeFuse-Embeddings</b></a>{' '} and {' '}<a href="https://github.com/codefuse-ai/SWE-CARE" target="_blank" rel="noreferrer"><b style={{ color: "#333333", textDecoration: "underline" }}>SWE-CARE</b></a>{' '} repositories.
                                    </p>
                                </li>

                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle services__modal-icon"></i>
                                    <p className="services__modal-info achievement__justify">
                                        Earned 
                                        {' '}<b>7 ECTS</b>{' '}
                                        <img
                                            src={helsinki}
                                            alt="University of Helsinki Full Stack Open certificate"
                                            className="popUpImg-left"
                                            style={{top: "0%", width: "90%", height: '100%'}}
                                        />
                                        credits from <b>University of Helsinki</b> with score <b>21.5 out of 26</b> in <b>Full Stack Open</b>.
                                    </p>
                                </li>

                                
                                {/* Cloud Certifications */}
                                <li className="services__modal-service">
                                    <i className="services__modal-icon">
                                        <SiMicrosoftazure />
                                    </i>
                                    <p className="services__modal-info achievement__justify">
                                        Nailed the  
                                        {' '}<a href="https://learn.microsoft.com/en-us/users/bbkx/credentials/certification/azure-ai-engineer?tab=credentials-tab" target="_blank" rel="noreferrer"><b style={{ color: "#333333", textDecoration: "underline" }}>Azure AI Engineer Associate (AI-102)</b></a>{' '}
                                        exam! <b>845/1000</b>
                                    </p>
                                </li>

                                <li className="services__modal-service">
                                    <i className="services__modal-icon">
                                        <SiMicrosoftazure />
                                    </i>
                                    <p className="services__modal-info achievement__justify">
                                        Nailed the  
                                        {' '}<a href="https://learn.microsoft.com/en-us/users/bbkx/credentials/certification/azure-ai-fundamentals?tab=credentials-tab" target="_blank" rel="noreferrer"><b style={{ color: "#333333", textDecoration: "underline" }}>Azure AI Fundamentals (AI-900)</b></a>{' '}
                                        exam! <b>914/1000</b>
                                    </p>
                                </li>
                                
                                <li className="services__modal-service">
                                    <i className="services__modal-icon">
                                        <SiMicrosoftazure />
                                    </i>
                                    <p className="services__modal-info achievement__justify">
                                        Crushed the
                                        {' '}<a href="https://www.credly.com/badges/1235d2eb-fe9e-4603-bd5a-e1e19ba5c293/public_url" target="_blank" rel="noreferrer"><b style={{ color: "#333333", textDecoration: "underline" }}>Azure Fundamentals (AZ-900)</b></a>{' '}
                                        exam! <b>931/1000</b>
                                    </p>
                                </li>

                                <li className="services__modal-service">
                                    <i className="services__modal-icon">
                                        <FaAws />
                                    </i>
                                    <p className="services__modal-info achievement__justify">
                                        Nailed the
                                        {' '}<a href="https://www.credly.com/earner/earned/badge/57819b1f-ccde-4ae2-bd91-7d3975edbc98" target="_blank" rel="noreferrer"><b style={{ color: "#333333", textDecoration: "underline" }}>AWS Cloud Practitioner (CLF-C02)</b></a>{' '}
                                        exam! <b>838/1000</b>
                                    </p>
                                </li>


                                <li className="services__modal-service">
                                    <i className="services__modal-icon">
                                        <FaGoogle />
                                    </i>
                                    <p className="services__modal-info achievement__justify">
                                        Snagged the
                                        {' '}<a href="https://www.credly.com/badges/90450c95-f01e-42ef-b943-558d529d9b5a/public_url" target="_blank" rel="noreferrer"><b style={{ color: "#333333", textDecoration: "underline" }}>Google IT Support Professional Certificate</b></a>
                                    </p>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Services